import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { IcoArrowR, IcoClock } from './icons';

// Standard placeholder for areas the Claude-design mocks introduced but that
// are not wired to real functionality yet. Use this instead of shipping mock
// data. When a feature is built, flip its `status` to 'available' and render
// the real component instead of this.
//
// If a real (legacy) implementation already exists elsewhere, pass
// `legacyPath`/`legacyLabel` so users can still reach working functionality.
const ComingSoon = ({ title, summary, planned, legacyPath, legacyLabel }) => {
  const navigate = useNavigate();
  return (
    <div
      className="bz-card"
      style={{
        padding: 40,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 12
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 10,
          background: 'var(--bg-tan)',
          color: 'var(--ink-muted)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <IcoClock size={22} />
      </div>

      <div className="bz-row" style={{ gap: 8 }}>
        <span className="bz-h3">{title}</span>
        <span className="bz-pill bz-pill--predict">Coming soon</span>
      </div>

      {summary && (
        <p style={{ margin: 0, color: 'var(--ink-soft)', fontSize: 'var(--fs-md)', maxWidth: 460, lineHeight: 1.5 }}>
          {summary}
        </p>
      )}

      {Array.isArray(planned) && planned.length > 0 && (
        <ul
          style={{
            textAlign: 'left',
            margin: '4px 0 0',
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            color: 'var(--ink-soft)',
            fontSize: 'var(--fs-sm)'
          }}
        >
          {planned.map(item => (
            <li key={item} className="bz-row" style={{ gap: 8 }}>
              <span style={{ width: 5, height: 5, borderRadius: 999, background: 'var(--ink-faint)', flexShrink: 0 }} />
              {item}
            </li>
          ))}
        </ul>
      )}

      {legacyPath && (
        <button
          type="button"
          className="bz-btn bz-btn--sm bz-btn--primary"
          style={{ marginTop: 8 }}
          onClick={() => navigate(legacyPath)}
        >
          {legacyLabel || 'Open the current page'} <IcoArrowR size={13} />
        </button>
      )}
    </div>
  );
};

ComingSoon.propTypes = {
  title: PropTypes.string.isRequired,
  summary: PropTypes.string,
  planned: PropTypes.arrayOf(PropTypes.string),
  legacyPath: PropTypes.string,
  legacyLabel: PropTypes.string
};

export default ComingSoon;
